const gamerules = {
    en: {
        baccarat:
            '<p class="toptitle">Baccarat:</p>' +
            '<p class="title">Introduction:</p>' +
            '<p> Baccarat has long been one of the most popular games in Asia, Europe and Latin America. It is simple to play, yet exciting and tense! </p>' +
            '<p class="title">How to win:</p>' +
            '<p> In Baccarat, two hands are dealt: &lt;&lt;Banker&gt;&gt; and &lt;&lt;Player&gt;&gt;. The hand totaling 9 points or closest to 9 wins. </p>' +
            '<p class="title">Operation and betting guide:</p>' +
            '<p> 1. Click a chip to bet, then click any betting area on the table (Player, Banker or Tie). </p>' +
            '<p> 2. Player and Banker are each dealt two cards. A sum of 10 counts as 0 points. If the sum exceeds 9, only the units digit is counted. </p>' +
            '<p> 3. If either hand gets 8 or 9 points (Natural), the round ends and no more cards are drawn. </p>' +
            '<p> 4. After two cards are dealt, if either hand totals 0 to 7, a third card may be dealt according to the drawing rules. Drawing is not optional. </p>' +
            '<p>5. No hand receives more than three cards.</p>' +
            '<p class="title">Gameplay:</p>' +
            '<p> This game uses 8 decks of cards (52 cards each), totaling 416 cards. "Player" and "Banker" are each dealt two cards first, with "Player" dealt first. If the first round does not decide the winner, a second round is dealt according to the drawing rules, with a maximum of 3 cards per side. The side closest to 9 wins; equal points result in a Tie. </p>' +
            '<p class="title">Game rules:</p>' +
            '<p class="tabletitle">1. Points calculation</p>' +
            '<table>' +
            '<tbody>' +
            '<tr>' +
            '<th class="spetitle">Card</th>' +
            '<th class="spetitle">Points</th>' +
            '</tr>' +
            '<tr>' +
            '<td>2 to 9</td>' +
            '<td>Face value</td>' +
            '</tr>' +
            '<tr>' +
            '<td>Ace</td>' +
            '<td>1</td>' +
            '</tr>' +
            '<tr>' +
            '<td>K or Q or J or 10</td>' +
            '<td>0</td>' +
            '</tr>' +
            '</tbody>' +
            '</table>' +
            "<p> *When either hand's first two cards total 8 or 9, it is called a Natural. </p>" +
            '<p> *After two cards are dealt, if a draw is needed, one more card is dealt to the side that needs it according to the drawing rules. </p>' +
            '<p>Examples:</p>' +
            '<p>4 + 2 + 6 = 2</p>' +
            '<p>5 + 6 + 8 = 9</p>' +
            '<p>10 + 10 + 10 = 0</p>' +
            '<p class="tabletitle">2. Drawing rules:</p>' +
            '<table>' +
            '<tbody>' +
            '<tr>' +
            '<th class="spetitle"> Player two-card total </th>' +
            '<th class="spetitle">(Player)</th>' +
            '<th class="spetitle"> Banker two-card total </th>' +
            '<th class="spetitle">(Banker)</th>' +
            '</tr>' +
            '<tr>' +
            '<td>0</td>' +
            '<td>Must draw</td>' +
            '<td>0</td>' +
            '<td>Must draw</td>' +
            '</tr>' +
            '<tr>' +
            '<td>1</td>' +
            '<td>Must draw</td>' +
            '<td>1</td>' +
            '<td>Must draw</td>' +
            '</tr>' +
            '<tr>' +
            '<td>2</td>' +
            '<td>Must draw</td>' +
            '<td>2</td>' +
            '<td>Must draw</td>' +
            '</tr>' +
            '<tr>' +
            '<td>3</td>' +
            '<td>Must draw</td>' +
            '<td>3</td>' +
            "<td> If Player's third card is 8, Banker does not draw </td>" +
            '</tr>' +
            '<tr>' +
            '<td>4</td>' +
            '<td>Must draw</td>' +
            '<td>4</td>' +
            "<td> If Player's third card is 0, 1, 8 or 9, Banker does not draw </td>" +
            '</tr>' +
            '<tr>' +
            '<td>5</td>' +
            '<td>Must draw</td>' +
            '<td>5</td>' +
            "<td> If Player's third card is 0, 1, 2, 3, 8 or 9, Banker does not draw </td>" +
            '</tr>' +
            '<tr>' +
            '<td>6</td>' +
            '<td>Does not draw</td>' +
            '<td>6</td>' +
            "<td> If Player's third card is 6 or 7, Banker must draw </td>" +
            '</tr>' +
            '<tr>' +
            '<td>7</td>' +
            '<td>Does not draw</td>' +
            '<td>7</td>' +
            '<td>Does not draw</td>' +
            '</tr>' +
            '<tr>' +
            '<td>8</td>' +
            '<td>Natural — result is decided</td>' +
            '<td>8</td>' +
            '<td>Natural — result is decided</td>' +
            '</tr>' +
            '<tr>' +
            '<td>9</td>' +
            '<td>Natural — result is decided</td>' +
            '<td>9</td>' +
            '<td>Natural — result is decided</td>' +
            '</tr>' +
            '</tbody>' +
            '</table>' +
            "<p> *If either Banker or Player has two cards totaling 8 or 9 (Natural), the other side does not draw and the result is decided. If both sides' first two cards are 6 or 7, it is a Tie. </p>" +
            '<p class="title">Payout odds:</p>' +
            '<p class="tabletitle"> This game offers Baccarat and Commission-free Baccarat. Drawing rules and bet types are the same for both, but Banker payouts differ. Bet types and payouts are as follows: </p>' +
            '<table>' +
            '<tbody>' +
            '<tr>' +
            '<th class="spetitle"> Bet type </th>' +
            '<th class="spetitle">Odds</th>' +
            '</tr>' +
            '<tr>' +
            '<td>Player</td>' +
            '<td> 1 ：1 (stake returned on Tie) </td>' +
            '</tr>' +
            '<tr>' +
            '<td>Banker</td>' +
            '<td> 1 ：0.95 (stake returned on Tie) </td>' +
            '</tr>' +
            '<tr>' +
            '<td>Non-commission Banker</td>' +
            '<td> 1 ：1 (if Banker wins with 6, pays half; stake returned on Tie) </td>' +
            '</tr>' +
            '<tr>' +
            '<td>Tie</td>' +
            '<td>1 ：8</td>' +
            '</tr>' +
            '<tr>' +
            '<td>Player Pair</td>' +
            '<td>1 ：11</td>' +
            '</tr>' +
            '<tr>' +
            '<td>Banker Pair</td>' +
            '<td>1 ：11</td>' +
            '</tr>' +
            '<tr>' +
            '<td>Super 6</td>' +
            '<td>1：12</td>' +
            '</tr>' +
            '<tr>' +
            '<td>Dragon 7</td>' +
            '<td>1 ：40</td>' +
            '</tr>' +
            '<tr>' +
            '<td>Panda 8</td>' +
            '<td>1 ：25</td>' +
            '</tr>' +
            '<tr>' +
            '<td>Big Tiger</td>' +
            '<td>1 ：50</td>' +
            '</tr>' +
            '<tr>' +
            '<td>Small Tiger</td>' +
            '<td>1 ：22</td>' +
            '</tr>' +
            '</tbody>' +
            '</table>' +
            '<p class="title">Special bet descriptions:</p>' +
            '<p>• <b>Super 6:</b>Banker wins with a total of 6 points.</p>' +
            '<p> • <b>Dragon 7:</b>Banker has exactly 3 cards totaling 7, and Banker wins. </p>' +
            '<p> • <b>Panda 8:</b>Player has exactly 3 cards totaling 8, and Player wins. </p>' +
            '<p> • <b>Big Tiger:</b>Banker has exactly 3 cards totaling 6, and Banker wins. </p>' +
            '<p> • <b>Small Tiger:</b>Banker has exactly 2 cards totaling 6, and Banker wins. </p>' +
            '<p>  Big/Small Tiger and Super6 cannot be bet simultaneously. </p>' +
            '<p class="title"> Note: After the 35th hand of each shoe, Dragon 7, Panda 8, Big Tiger and Small Tiger bets are not accepted. </p>' +
            '<p class="title">Banker/Player Pair:</p>' +
            "<p> If Banker's first and second cards have the same points, it is a Banker Pair. If Player's first and second cards have the same points, it is a Player Pair. </p>" +
            '<p><b>Natural definition: The first two cards total 8 or 9 points</b></p>' +
            '<p><b>Non-Natural definition: All situations other than a Natural</b></p>' +
            '<p class="title">Please note:</p>' +
            '<p> • When the dealer is dealing, the system may occasionally fail to read a card. The dealer will rescan until the system can read it completely (in case of failure, all related bets/payouts will be voided). </p>' +
            '<p> • In case of a settlement error, resettlement will be based on the current video result. </p>',
        dragontiger:
            '<h3>Introduction:</h3>' +
            '<p>A gambling game that determines winning or losing based on the number of card points. It is simple and easy to learn, allowing players to fully experience the fun of the casino!</p>' +
            '<h3>How to win:</h3>' +
            '<p>It is correctly estimated that the points of the two players, &lt;&lt;Dragon&gt;&gt; and &lt;&lt;Tiger&gt;&gt;, are relatively large. </p>' +
            '<h3>Operation and Betting Guide:</h3>' +
            '<ol>' +
            '<li>Click on the bet chip, then click on any piece on the table to bet (Dragon, Tiger or Tie). </li>' +
            '<li>The dealer only sends two cards, one card to each door, namely dragon and tiger, and the two sides fight for victory. </li>' +
            '</ol>' +
            '<h3>Gameplay:</h3>' +
            '<ol>' +
            '<li>The cards are compared first, with K being the highest card and A being the smallest. If the points are the same, compare the suits, spades&gt;hearts&gt;clubs&gt;diamond</li>' +
            '<li>The dealer first distributes the first card to the dragon position, and the second card to the tiger position. The one with higher points wins, and the one with the same number and higher suit wins</li>' +
            '</ol>' +
            '<h3>Odds:</h3>' +
            '<table>' +
            '<thead>' +
            '<tr>' +
            '<td class="size-256 head">Betting items</td>' +
            '<td class="size-256 head">Odds</td>' +
            '</tr>' +
            '</thead>' +
            '<tbody>' +
            '<tr>' +
            '<td>Dragon</td>' +
            '<td>1:1 (When the game ends in a tie, all lose)</td>' +
            '</tr>' +
            '<tr>' +
            '<td>Tiger</td>' +
            '<td>1:1 (When the game ends in a tie, all lose)</td>' +
            '</tr>' +
            '<tr>' +
            '<td>and</td>' +
            '<td>1：8</td>' +
            '</tr>' +
            '</tbody>' +
            '</table>' +
            '<h3>Please note:</h3>' +
            '<p>' +
            '•' +
            'When the dealer is dealing cards, occasionally the system cannot interpret the situation. At this time, the dealer will rescan until the system can completely interpret (in case of failure, all related orders/payments will be canceled). ' +
            '</p>' +
            '<p>• If there is a settlement error, settlement will be made again based on the current video results. </p>'
    },
    'zh-cn': {
        baccarat:
            '<p class="toptitle">百家乐:</p>' +
            '<p class="title">简介:</p>' +
            '<p> 长期以来，百家乐是亚洲、欧洲和拉丁美洲最受欢迎的游戏之一，玩法简单，却刺激紧张! </p>' +
            '<p class="title">如何胜出:</p>' +
            '<p> 百家乐中将发两份牌&lt;&lt;庄家&gt;&gt; 和&lt;&lt;闲家&gt;&gt;，总数得9点或最接近9 点的一家胜出。 </p>' +
            '<p class="title">操作及下注指南:</p>' +
            '<p> 1. 点击下注的筹码，再点击桌上下注任何一块( 闲家、庄家或平局)。 </p>' +
            '<p> 2. 闲家和庄家将获发两张牌，加起来等於10作0点，总和超过9，则只算总数中的个位。 </p>' +
            '<p> 3. 任何一家拿到8或9点（天生赢家），牌局就算结束，不再补牌。 </p>' +
            '<p> 4. 派出两张牌後，如果任何一手牌的头两张牌的牌面为0至7，将依照补牌规则多发一张牌，不可以任选补牌。 </p>' +
            '<p>5. 没有任何一手牌获得超过三张牌。</p>' +
            '<p class="title">游戏玩法:</p>' +
            '<p> 本游戏采用8副牌（每副牌52张）来进行，游戏牌数合计416张。“闲家”“庄家”各先派两张牌，以“闲家”先发，如第一轮未分出胜负需再按“牌例”发第二轮的牌，最多每方3张牌，谁最接近9点即为胜方，而相同点数即和局 </p>' +
            '<p class="title">游戏规则:</p>' +
            '<p class="tabletitle">1.点数计算</p>' +
            '<table>' +
            '<tbody>' +
            '<tr>' +
            '<th class="spetitle">牌面</th>' +
            '<th class="spetitle">点数</th>' +
            '</tr>' +
            '<tr>' +
            '<td>2 至 9</td>' +
            '<td>根据其数值显示的点数</td>' +
            '</tr>' +
            '<tr>' +
            '<td>Ace</td>' +
            '<td>1</td>' +
            '</tr>' +
            '<tr>' +
            '<td>K 或 Q 或 J 或 10</td>' +
            '<td>0</td>' +
            '</tr>' +
            '</tbody>' +
            '</table>' +
            '<p> *当任何一家头两张牌的点数总和为8或9，就称为(天生赢家)。 </p>' +
            '<p> *派出两张牌後，如果需要补牌，将依照博牌规则向需要补牌方多发一张牌 </p>' +
            '<p>例子:</p>' +
            '<p>4 + 2 + 6 = 2</p>' +
            '<p>5 + 6 + 8 = 9</p>' +
            '<p>10 + 10 + 10 = 0</p>' +
            '<p class="tabletitle">2.补牌规则:</p>' +
            '<table>' +
            '<tbody>' +
            '<tr>' +
            '<th class="spetitle"> 闲两牌合计点数 </th>' +
            '<th class="spetitle">(闲家)</th>' +
            '<th class="spetitle"> 庄两牌合计点数 </th>' +
            '<th class="spetitle">(庄家)</th>' +
            '</tr>' +
            '<tr>' +
            '<td>0</td>' +
            '<td>必须博牌</td>' +
            '<td>0</td>' +
            '<td>必须博牌</td>' +
            '</tr>' +
            '<tr>' +
            '<td>1</td>' +
            '<td>必须博牌</td>' +
            '<td>1</td>' +
            '<td>必须博牌</td>' +
            '</tr>' +
            '<tr>' +
            '<td>2</td>' +
            '<td>必须博牌</td>' +
            '<td>2</td>' +
            '<td>必须博牌</td>' +
            '</tr>' +
            '<tr>' +
            '<td>3</td>' +
            '<td>必须博牌</td>' +
            '<td>3</td>' +
            '<td> 若闲家博得第三张牌是8点，庄家不得博牌 </td>' +
            '</tr>' +
            '<tr>' +
            '<td>4</td>' +
            '<td>必须博牌</td>' +
            '<td>4</td>' +
            '<td> 若闲家博得第三张牌是0，1，8，9点， 庄家不得博牌 </td>' +
            '</tr>' +
            '<tr>' +
            '<td>5</td>' +
            '<td>必须博牌</td>' +
            '<td>5</td>' +
            '<td> 若闲家博得第三张牌是0，1，2，3，8，9点， 庄家不得博牌 </td>' +
            '</tr>' +
            '<tr>' +
            '<td>6</td>' +
            '<td>不得博牌</td>' +
            '<td>6</td>' +
            '<td> 若闲家博得第三张牌是6 或 7点，庄家必须博牌 </td>' +
            '</tr>' +
            '<tr>' +
            '<td>7</td>' +
            '<td>不得博牌</td>' +
            '<td>7</td>' +
            '<td>不得博牌</td>' +
            '</tr>' +
            '<tr>' +
            '<td>8</td>' +
            '<td>例牌，即定胜负</td>' +
            '<td>8</td>' +
            '<td>例牌，即定胜负</td>' +
            '</tr>' +
            '<tr>' +
            '<td>9</td>' +
            '<td>例牌，即定胜负</td>' +
            '<td>9</td>' +
            '<td>例牌，即定胜负</td>' +
            '</tr>' +
            '</tbody>' +
            '</table>' +
            '<p> *庄闲任何一方两牌合计8、9点为例牌，对方不须博牌，即定胜负。庄闲两方头两张牌各得6或7点，即和局。 </p>' +
            '<p class="title">派彩赔率:</p>' +
            '<p class="tabletitle"> 本游戏为玩家提供百家乐玩法和免佣百家乐玩法。这两种玩法的博牌规则和投注种类一致，但投注庄的派彩方式有区别。其投注种类与派彩分别如下∶ </p>' +
            '<table>' +
            '<tbody>' +
            '<tr>' +
            '<th class="spetitle"> 投注项目 </th>' +
            '<th class="spetitle">赔率</th>' +
            '</tr>' +
            '<tr>' +
            '<td>闲家</td>' +
            '<td> 1 ：1 (开和局时退回下注金额) </td>' +
            '</tr>' +
            '<tr>' +
            '<td>庄家</td>' +
            '<td> 1 ：0.95 (开和局时退回下注金额) </td>' +
            '</tr>' +
            '<tr>' +
            '<td>免佣庄</td>' +
            '<td> 1 ：1 (如庄以6点取胜，则赔一半；开和局时退回下注金额) </td>' +
            '</tr>' +
            '<tr>' +
            '<td>和局</td>' +
            '<td>1 ：8</td>' +
            '</tr>' +
            '<tr>' +
            '<td>闲对子</td>' +
            '<td>1 ：11</td>' +
            '</tr>' +
            '<tr>' +
            '<td>庄对子</td>' +
            '<td>1 ：11</td>' +
            '</tr>' +
            '<tr>' +
            '<td>超级 6</td>' +
            '<td>1：12</td>' +
            '</tr>' +
            '<tr>' +
            '<td>龙7</td>' +
            '<td>1 ：40</td>' +
            '</tr>' +
            '<tr>' +
            '<td>熊8</td>' +
            '<td>1 ：25</td>' +
            '</tr>' +
            '<tr>' +
            '<td>大老虎</td>' +
            '<td>1 ：50</td>' +
            '</tr>' +
            '<tr>' +
            '<td>小老虎</td>' +
            '<td>1 ：22</td>' +
            '</tr>' +
            '</tbody>' +
            '</table>' +
            '<p class="title">特殊投注说明:</p>' +
            '<p>• <b>超级6：</b>庄家以合计6点胜出。</p>' +
            '<p> • <b>龙7：</b>庄家必为3张牌，且点数合计为7点，庄家赢。 </p>' +
            '<p> • <b>熊8：</b>闲家必为3张牌，且点数合计为8点，闲家赢。 </p>' +
            '<p> • <b>大老虎：</b>庄家必为3张牌，且点数合计为6点，庄家赢。 </p>' +
            '<p> • <b>小老虎：</b>庄家必为2张牌，且点数合计为6点，庄家赢。 </p>' +
            '<p>  大小老虎和超级六不可同时下注。 </p>' +
            '<p class="title"> 备注：每靴第35局以后不接受龙7、熊8、大老虎、小老虎投注。 </p>' +
            '<p class="title">庄/闲对子:</p>' +
            '<p> 庄的第一张和第二张牌点数相同，则为庄对子。闲的第一张和第二张牌点数相同，则为闲对子。 </p>' +
            '<p><b>例牌定义：首两牌结果为8或9点</b></p>' +
            '<p><b>非例牌定义：例牌之外的所有情况</b></p>' +
            '<p class="title">请注意 :</p>' +
            '<p> • 荷官发牌时，偶有系统无法判读状况时，此时荷官将重新扫描，直到系统能够完整判读(如遇故障因素将注销所有相关注单/派彩)。 </p>' +
            '<p> • 如遇结算错误，按照当期视频结果重新结算。 </p>',
        dragontiger:
            '<h3>简介:</h3>' +
            '<p>一个以牌面点数大小来决定输赢的博彩游戏，简单易学，让玩家完全体验赌场的趣味!</p>' +
            '<h3>如何胜出:</h3>' +
            '<p>正确预计两家&lt;&lt;龙&gt;&gt; 和&lt;&lt;虎&gt;&gt;的点数比较大。</p>' +
            '<h3>操作及下注指南:</h3>' +
            '<ol>' +
            '<li>点击下注的筹码，再点击桌上下注任何一块 (龙、虎或平局 )。</li>' +
            '<li>荷官只派两门牌，每门各派一只牌，即龙与虎，双方斗大。</li>' +
            '</ol>' +
            '<h3>游戏玩法：</h3>' +
            '<ol>' +
            '<li>牌面的先比点数，K为最大牌，A为最小。如点数相同，则比较花色，黑桃&gt;红桃&gt;梅花&gt;方块</li>' +
            '<li>荷官先派发第一张牌于龙的位置，而第二张牌派发到虎的位置，点数较大的胜出，点数相同花色大的胜出</li>' +
            '</ol>' +
            '<h3>派彩赔率:</h3>' +
            '<table>' +
            '<thead>' +
            '<tr>' +
            '<td class="size-256 head">投注项目</td>' +
            '<td class="size-256 head">赔率</td>' +
            '</tr>' +
            '</thead>' +
            '<tbody>' +
            '<tr>' +
            '<td>龙</td>' +
            '<td>1 ：1 (开和局时，全输)</td>' +
            '</tr>' +
            '<tr>' +
            '<td>虎</td>' +
            '<td>1 ：1 (开和局时，全输)</td>' +
            '</tr>' +
            '<tr>' +
            '<td>和</td>' +
            '<td>1：8</td>' +
            '</tr>' +
            '</tbody>' +
            '</table>' +
            '<h3>请注意 :</h3>' +
            '<p>' +
            '•' +
            '荷官发牌时，偶有系统无法判读状况时，此时荷官将重新扫描，直到系统能够完整判读(如遇故障因素将注销所有相关注单/派彩)。' +
            '</p>' +
            '<p>• 如遇结算错误，按照当期视频结果重新结算。</p>'
    }
}

export default gamerules
